import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export interface RuleLock {
  ruleId: Number
  typeOfLock: String
  userId: String
}

export const locksSlice = createSlice({
  name: 'locks',
  initialState: {
    locks: [] as RuleLock[],
  },
  reducers: {
    setLocks: (state, action: PayloadAction<RuleLock[]>) => {
      state.locks = action.payload
    },
    addLock: (state, action: PayloadAction<RuleLock>) => {
      state.locks.push(action.payload)
    },
  },
})

export const { setLocks, addLock } = locksSlice.actions

export default locksSlice.reducer
